import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Grid, GridItem, Text, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import {CheckIcon} from '../../icons/others'

const ProductCompareGrid = ({
    gridData,
    isOnPDP = false,
    numOfProducts = 2,
    colorlessHeaders = false,
    highlightDifferences = false,
}) => {
    const styles = useMultiStyleConfig('ProductCompare', {colorlessHeaders})
    const columns = useBreakpointValue({base: numOfProducts, lg: numOfProducts + 1})
    const headingHighlightColor = useBreakpointValue({
        base: 'inherit',
        lg: 'background.light-blue',
    })
    return (
        <Grid
            templateColumns={`repeat(${columns}, 1fr)`}
            {...styles.grid}
            data-testid="product-compare-grid"
        >
            {gridData?.map((gridRow) => {
                const areAllValuesTheSame = gridRow?.values?.every(
                    (value) => value === gridRow?.values[0],
                )
                const shouldHighlight = highlightDifferences && !areAllValuesTheSame
                return (
                    <Fragment key={gridRow.id}>
                        <GridItem
                            colSpan={{base: numOfProducts, lg: 1}}
                            {...styles.gridCell}
                            {...styles.gridHeading}
                            backgroundColor={{
                                base: shouldHighlight
                                    ? headingHighlightColor
                                    : isOnPDP
                                    ? 'background.light'
                                    : 'inherit',
                                lg: shouldHighlight ? headingHighlightColor : 'inherit',
                            }}
                        >
                            <Text>{gridRow?.label}</Text>
                        </GridItem>
                        {gridRow?.values?.map((value, index) => (
                            <GridItem
                                key={index}
                                {...styles.gridCell}
                                {...styles.productsTypo}
                                backgroundColor={
                                    shouldHighlight ? 'background.light-blue' : 'inherit'
                                }
                            >
                                {value === 'true' ? (
                                    <CheckIcon
                                        data-testid="check-icon"
                                        color="button.background.primary-default"
                                    />
                                ) : (
                                    <Text
                                        wordBreak={'break-all'}
                                        whiteSpace={'pre-line'}
                                        textOverflow={'ellipsis'}
                                    >
                                        {value}
                                    </Text>
                                )}
                            </GridItem>
                        ))}
                    </Fragment>
                )
            })}
        </Grid>
    )
}

ProductCompareGrid.propTypes = {
    gridData: PropTypes.array,
    isOnPDP: PropTypes.bool,
    numOfProducts: PropTypes.number,
    colorlessHeaders: PropTypes.bool,
    highlightDifferences: PropTypes.bool,
}

export default ProductCompareGrid
